import {
  NavigateWithThread,
  FocusDashboard,
  Profile,
  TopSkillDetailPage,
  OrganisationProfile,
  EmployerOrganisationHubPage,
  EmployerOrganisationSettingsGate,
  EmployerOrganisationSettingsSlugLayout,
  managedEmployerOrganisationSwitcherEnabled,
} from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { EmployerOrganisationsPage } from '../../../components/employer/organisations-page'
import { EmployerOrganisationSetupWizard } from '../../../components/employer/employer-organisation-setup-wizard'
import { EmployerOpportunitiesPage } from '../../../components/employer/opportunities-page'
import {
  JobWorkspaceTalentRoute,
  JobWorkspaceApplicantsRoute,
  JobWorkspaceDefaultRedirect,
  JobWorkspaceLayout,
  JobWorkspaceSetupRoute,
  JobWorkspaceSuggestionsRoute,
} from '../../../components/employer/job-workspace-page'
import { JobWorkspaceEvaluationDetailPage } from '../../../components/employer/job-workspace-evaluation-detail-page'
import { JobWorkspacePersonPage } from '../../../components/employer/job-workspace-person-page'

interface EmployerRoutesProps {
  onStartConversation?: (message: string) => void
}

/** Plural list for non-switcher tenants; redirect to singular hub when switcher enabled. */
function EmployerOrganisationsRedirectOrList() {
  if (managedEmployerOrganisationSwitcherEnabled()) {
    return <NavigateWithThread to="/employer/organisation" />
  }
  return <EmployerOrganisationsPage />
}

/** Singular hub when switcher enabled; otherwise plural list is canonical — redirect unknown hub URL away. */
function EmployerOrganisationIndexGate() {
  if (managedEmployerOrganisationSwitcherEnabled()) {
    return <EmployerOrganisationHubPage />
  }
  return <NavigateWithThread to="/employer/organisations" />
}

export function EmployerRoutes({ onStartConversation }: EmployerRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard focus="employer" onStartConversation={onStartConversation} />
        }
      />
      <Route path="profile/top-skills/:skillId" element={<TopSkillDetailPage />} />
      <Route path="profile" element={<Profile />} />
      <Route path="organisations" element={<EmployerOrganisationsRedirectOrList />} />
      <Route path="organisation/settings/*" element={<EmployerOrganisationSettingsGate />} />
      <Route path="organisation/:slug/settings/*" element={<EmployerOrganisationSettingsSlugLayout />} />
      <Route path="organisation/:slug/setup" element={<EmployerOrganisationSetupWizard />} />
      <Route path="organisation" element={<EmployerOrganisationIndexGate />} />
      <Route path="organisation/:slug" element={<OrganisationProfile />} />
      <Route path="jobs" element={<EmployerOpportunitiesPage onStartConversation={onStartConversation} />} />
      <Route
        path="jobs/:jobId/talent/:evaluationId"
        element={<JobWorkspaceEvaluationDetailPage />}
      />
      <Route path="jobs/:jobId/people/:profileId" element={<JobWorkspacePersonPage />} />
      <Route path="jobs/:jobId" element={<JobWorkspaceLayout />}>
        <Route index element={<JobWorkspaceDefaultRedirect />} />
        <Route path="details" element={<JobWorkspaceSetupRoute />} />
        <Route path="applicants" element={<JobWorkspaceApplicantsRoute />} />
        <Route path="applicants/:applicationId" element={<JobWorkspaceApplicantsRoute />} />
        <Route path="talent" element={<JobWorkspaceTalentRoute />} />
        <Route path="suggestions" element={<JobWorkspaceSuggestionsRoute />} />
      </Route>
      <Route path="organisations/:slug/jobs" element={<EmployerOpportunitiesPage onStartConversation={onStartConversation} />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
